import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-leo-external",
  "use": "icon-leo-external-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"icon-leo-external\">\r\n<g transform=\"translate(-163.840 -143.360) scale(1.280000)\">\r\n<path d=\"M192 192h448v448H192V192zm64 64v320h320V256H256z\" />\r\n  <path d=\"M544 448h288v384H544V448zm64 64v256h160V512H608z\" />\r\n  <path d=\"M704 288l160 160-48 48-112-112v240h-64V384L592 496l-48-48 160-160z\" />\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/leo-external.svg
// module id = 44rS
// module chunks = 446